export const createBackgroundImage = (avif: string, png: string): string => {
    return `image-set(url(${avif}) type("image/avif"), url(${png}) type("image/jpg"))`;
};
